import { ChangeEvent, Ref, MouseEvent } from 'react'

export interface Props {
  name: string
  type?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onClick?: (e: MouseEvent<HTMLInputElement>) => void
  value?: string
  defaultValue?: string
  inputRef?: Ref<HTMLInputElement>
}

export const useInput = (props: Props) => {
  const { name, type = 'text', defaultValue, value, onClick, inputRef } = props
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(e)
    }
  }

  return {
    name,
    type,
    value,
    defaultValue,
    inputRef,
    onChange,
    onClick,
  }
}
